import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AntTable from 'antd/lib/table';
import './style';

const propTypes = {
  ...AntTable.propTypes,
  className: PropTypes.string,
  responsive: PropTypes.bool,
};

class Table extends React.Component {
  constructor(props) {
    super(props);
    if (props.responsive) {
      this.responsiveColumns = props.columns.map((col) => {
        const newRender = (text, record, idx) => {
          if (typeof col.render === 'function') {
            return {
              children: col.render(text, record, idx),
              props: {
                'data-th': col.title,
              },
            };
          }
          return {
            children: text,
            props: {
              'data-th': col.title,
            },
          };
        };
        return {
          ...col,
          render: newRender,
        };
      });
    }
  }
  render() {
    const {
      className, columns, responsive, ...rest
    } = this.props;
    const computedClassName = classNames(
      'bsa-table',
      {
        'bsa-responsive-table': responsive,
      },
      className,
    );
    if (responsive) {
      return (
        <AntTable
          className={computedClassName}
          columns={this.responsiveColumns}
          {...rest}
        />
      );
    }
    return (
      <AntTable
        className={computedClassName}
        columns={columns}
        {...rest}
      />
    );
  }
}

Table.defaultProps = AntTable.defaultProps;
Table.propTypes = propTypes;
Table.Column = AntTable.Column;
Table.contextTypes = AntTable.contextTypes;
export default Table;
